import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import CardHeader from "@mui/material/CardHeader";
import { TextField } from "@material-ui/core";
import {
  verifyFirstLogin,
  isSessionExpired,
  setSessionActive,
  clearStoragePortal,
} from "../../api/services/AuthService";
import Alert from "@mui/material/Alert";
import { Link, useNavigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../../theme/Theme";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import befly from "../../../assets/images/befly.png";
import { useAuth } from "../../context/AuthContext";

import styled from "styled-components";
import LoginService from "../../api/services/LoginService";

const DivLogin = styled.div`
  background-color: #041e42;
  position: fixed;
  z-index: 0;
  width: 100%;
  height: 100%;
  background-attachment: fixed;
  background-size: cover;
  background-position: right top;
`;

const CardLogin = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
`;

const Titulo = styled(Typography)`
  flex-direction: row;
  flex-wrap: wrap;
  display: flex;
  position: relative;
  z-index: 2;
  color: #041e42;
  width: 100%;
  text-align: center;
`;

const CardHeaderLogin = styled(CardHeader)`
  background-color: #041e42;
  color: white;
  width: 600px;
`;

const AlertBadCredentials = styled(Alert)`
  margin-bottom: 5px;
  display: ${({ isvisible }) =>
    isvisible === "true" ? "flex !important" : "none !important"};
`;

const LinkMenu = styled(Link)`
  margin: 0;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: 0.00938em;
  display: block;
  color: inherit;
  text-decoration: none;
`;

const DivLogo = styled.div`
  align-items: center;
  z-index: -1;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  display: flex;
  position: relative;
`;

const ImagemLogo = styled.img`
  width: 450px;
  height: 220px;
`;

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [variant, setVariant] = useState("error");
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);

  let navigate = useNavigate();
  const servico = new LoginService();

  const { refreshAuth } = useAuth();

  // --------------------------------
  // Sessão expirada
  // --------------------------------
  useEffect(() => {
    const statusSessionExpired = () => {
      setVariant("warning");
      setMessage("Sessão Encerrada!");
      setError(true);
      clearStoragePortal();
    };
    if (error !== true && isSessionExpired() === true) {
      statusSessionExpired();
    }
  }, [variant, message, error]);

  // --------------------------------
  // SUBMIT DO LOGIN
  // --------------------------------
  const handleSubmit = (event) => {
    event.preventDefault();
    setOpen(true);
    setError(false);

    servico
      .autenticar({ username, password })
      .then((response) => {
        const jsonToken = response.data;
        servico.clearStorage();

        const user = verifyFirstLogin(jsonToken);

        setSessionActive();

        refreshAuth();

        if (!user.isReset) {
          navigate("/redefinirSenha", { replace: true });
        } else if (user.isAdmin) {
          navigate("/fatura", { replace: true });
        } else {
          navigate("/dashboard", { replace: true });
        }
      })
      .catch((erro) => {
        setError(true);
        setVariant("error");

        switch (erro?.response?.status) {
          case 401:
          case 403:
            setMessage("Credenciais Inválidas");
            break;
          default:
            setMessage(
              "Problema ao tentar logar, entre em contato com o administrador!",
            );
            break;
        }
      })
      .finally(() => setOpen(false));
  };

  return (
    <form onSubmit={handleSubmit}>
      <ThemeProvider theme={theme}>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <DivLogin>
          <DivLogo>
            <ImagemLogo src={befly} />
          </DivLogo>

          <CardLogin>
            <Card variant="outlined">
              <CardHeaderLogin title="PORTAL DE FATURAS" />
              <CardContent>
                <Titulo variant="h7" gutterBottom>
                  LOGIN:
                </Titulo>

                <TextField
                  id="username"
                  autoComplete="off"
                  label="Usuário"
                  type="text"
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  required
                  placeholder="Usuário"
                  value={username}
                  onChange={(event) => setUsername(event.target.value)}
                />

                <TextField
                  id="password"
                  autoComplete="off"
                  required
                  label="Senha"
                  type="password"
                  margin="normal"
                  placeholder="Senha"
                  variant="outlined"
                  fullWidth
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />

                <AlertBadCredentials
                  isvisible={error.toString()}
                  variant="filled"
                  severity={variant}
                >
                  {message}
                </AlertBadCredentials>

                <Grid container spacing={2} style={{ marginTop: 5 }}>
                  <Grid item xs={6}>
                    <Button type="submit" variant="contained" color="primary">
                      Logar
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <LinkMenu to="/recuperarSenha">
                      <ListItem>
                        <ListItemText
                          sx={{ color: "#041E42", textAlign: "right" }}
                          primary={"Esqueci minha senha"}
                        />
                      </ListItem>
                    </LinkMenu>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </CardLogin>
        </DivLogin>
      </ThemeProvider>
    </form>
  );
}
